import { render } from "./HeaderCarDetails.vue?vue&type=template&id=a38d7ade"
import script from "./HeaderCarDetails.vue?vue&type=script&lang=js"
export * from "./HeaderCarDetails.vue?vue&type=script&lang=js"

import "./HeaderCarDetails.vue?vue&type=style&index=0&id=a38d7ade&lang=scss"

import exportComponent from "/home/rubb/NiwCaetano/Frontend/governance/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__